// src/utils/currency.js
//
// Shared Rupiah helpers for Administrasi money fields (Anggaran, Realisasi
// Nota, Kas Masuk) — display formatting plus the parse/format pair used by
// RupiahInput to show grouped-thousands digits as the user types, so a
// price is never ambiguous between "15000" and "150000".

export const fmtRp = (n) => `Rp ${Number(n || 0).toLocaleString("id-ID")}`;

// "Rp 1.500.000" / "1.500.000" / "1500000" -> 1500000
export const parseRupiahInput = (str) => {
  const digits = String(str || "").replace(/\D/g, "");
  return digits ? parseInt(digits, 10) : 0;
};

// 1500000 -> "1.500.000" (no "Rp" prefix — for use inside an input's value)
export const formatRibuan = (value) => {
  if (value === "" || value === null || value === undefined) return "";
  const num = typeof value === "number" ? value : parseRupiahInput(value);
  return num.toLocaleString("id-ID");
};
